import { render, staticRenderFns } from "./TestingDialog.vue?vue&type=template&id=705b3682&lang=pug&"
import script from "./TestingDialog.vue?vue&type=script&lang=js&"
export * from "./TestingDialog.vue?vue&type=script&lang=js&"
import style0 from "./TestingDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TestingDialog.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VDialog,
  VProgressCircular,
})
